var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustrationTutorial2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 365 358",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-8",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 7,
    dy: 7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#110051",
    floodOpacity: 0.45
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-11",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-2",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#110051",
    floodOpacity: 0.35
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-2",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#drop-shadow-8)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M318.1,272.38l-245.42,27.65c-3.31.37-6.29-1.88-6.64-5.04l-14.92-132.48c-.36-3.16,2.04-6.02,5.35-6.39l245.42-27.65c3.31-.37,6.29,1.88,6.64,5.04l14.92,132.48c.36,3.16-2.04,6.02-5.35,6.39Z",
    style: {
      fill: "#1d254f",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "276.17 170.42 246.91 173.72 272.81 131.74 302.07 128.44 276.17 170.42",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "212.38 177.61 183.12 180.9 209.01 138.93 238.27 135.63 212.38 177.61",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "148.58 184.79 119.32 188.09 145.22 146.11 174.48 142.82 148.58 184.79",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "84.78 191.98 55.53 195.28 81.42 153.3 110.68 150 84.78 191.98",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.73,50.17L46.07,116.37c-3.3.92-5.24,4.33-4.34,7.64l6.93,25.42c.91,3.33,4.35,5.28,7.68,4.36l237.66-66.21c3.3-.92,5.24-4.33,4.34-7.64l-6.93-25.42c-.91-3.33-4.35-5.29-7.68-4.36Z",
    style: {
      fill: "#1d254f",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "258.88 57.09 230.51 64.99 270.04 94.25 298.42 86.35 258.88 57.09",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "197.01 74.33 168.64 82.23 208.17 111.49 236.55 103.59 197.01 74.33",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "135.14 91.56 106.76 99.47 146.3 128.73 174.68 120.82 135.14 91.56",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "73.27 108.8 44.89 116.7 84.43 145.96 112.81 138.06 73.27 108.8",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.1,201.24l-235.57,26.54c-1.6.18-3.05-.97-3.23-2.57s.97-3.05,2.57-3.23l235.57-26.54c1.6-.18,3.05.97,3.23,2.57s-.97,3.05-2.57,3.23Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.25,220.33l-235.57,26.54c-1.6.18-3.05-.97-3.23-2.57s.97-3.05,2.57-3.23l235.57-26.54c1.6-.18,3.05.97,3.23,2.57s-.97,3.05-2.57,3.23Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.4,239.43l-235.57,26.54c-1.6.18-3.05-.97-3.23-2.57s.97-3.05,2.57-3.23l235.57-26.54c1.6-.18,3.05.97,3.23,2.57s-.97,3.05-2.57,3.23Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.47,
    y: 202.61,
    width: 89.33,
    height: 56.17,
    rx: 2.08,
    ry: 2.08,
    transform: "translate(-24.64 22.62) rotate(-6.43)",
    style: {
      fill: "#1d254f",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.47,
    y: 202.61,
    width: 89.33,
    height: 56.17,
    rx: 2.08,
    ry: 2.08,
    transform: "translate(-24.64 22.62) rotate(-6.43)",
    style: {
      fill: "#8058ee",
      opacity: 0.4,
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.94,257.19l-76.67,8.64c-4.93.56-9.4-3.01-9.96-7.94l-4.93-43.72c-.56-4.94,3.01-9.4,7.94-9.96l76.67-8.64c4.93-.56,9.4,3.01,9.96,7.94l4.93,43.72c.56,4.94-3.01,9.4-7.94,9.96ZM147.98,210.01c-1.73.2-2.99,1.77-2.79,3.5l4.93,43.72c.2,1.74,1.77,2.99,3.5,2.79l76.67-8.64c1.73-.2,2.99-1.77,2.79-3.5l-4.93-43.72c-.2-1.74-1.77-2.99-3.5-2.79l-76.67,8.64Z",
    style: {
      fill: "#f4f4f4",
      strokeWidth: 0
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#drop-shadow-11)",
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "49.2 46.96 54.11 53.37 62.17 52.96 57.59 59.6 60.47 67.14 52.74 64.85 46.46 69.92 46.25 61.85 39.49 57.45 47.1 54.76 49.2 46.96",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "40.2 300.96 45.11 307.37 53.17 306.96 48.59 313.6 51.47 321.14 43.74 318.85 37.46 323.92 37.25 315.85 30.49 311.45 38.1 308.76 40.2 300.96",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "343.24 98.15 344.77 106.07 352.16 109.31 345.1 113.21 344.31 121.24 338.41 115.73 330.53 117.45 333.95 110.15 329.87 103.18 337.88 104.18 343.24 98.15",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "194.71 22.63 195.48 26.62 199.2 28.24 195.64 30.21 195.24 34.25 192.28 31.48 188.31 32.35 190.03 28.67 187.98 25.16 192.01 25.66 194.71 22.63",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "237.71 317.63 238.48 321.62 242.2 323.24 238.64 325.21 238.24 329.25 235.28 326.48 231.31 327.35 233.03 323.67 230.98 320.16 235.01 320.66 237.71 317.63",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "308.71 295.63 309.48 299.62 313.2 301.24 309.64 303.21 309.24 307.25 306.28 304.48 302.31 305.35 304.03 301.67 301.98 298.16 306.01 298.66 308.71 295.63",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "92.71 63.63 93.48 67.62 97.2 69.24 93.64 71.21 93.24 75.25 90.28 72.48 86.31 73.35 88.03 69.67 85.98 66.16 90.01 66.66 92.71 63.63",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "336.71 130.63 337.48 134.62 341.2 136.24 337.64 138.21 337.24 142.25 334.28 139.48 330.31 140.35 332.03 136.67 329.98 133.16 334.01 133.66 336.71 130.63",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "71.71 323.63 72.48 327.62 76.2 329.24 72.64 331.21 72.24 335.25 69.28 332.48 65.31 333.35 67.03 329.67 64.98 326.16 69.01 326.66 71.71 323.63",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationTutorial2);
export default __webpack_public_path__ + "static/media/illustrationTutorial2.e16951f53a673b4c4a4eb0188f7e83c6.svg";
export { ForwardRef as ReactComponent };